export const config = {
  title: "Loren'z Cleaning LLC | Professional Cleaning Services | Queens, NY",
  meta: {
    description:
      "Loren'z Cleaning LLC provides exceptional and thorough cleaning services for homes, offices, and construction sites in Queens, NY. Standard, deep, residential, commercial, and post-construction cleaning.",
    keywords: [
      "Loren'z Cleaning LLC",
      "Cleaning Services Queens",
      "Residential Cleaning NY",
      "Commercial Cleaning Queens",
      "Deep Cleaning Services",
      "Post Construction Cleaning",
      "Office Cleaning Queens",
      "Professional Cleaning"
    ],
    author: "Loren'z Cleaning LLC",
    canonicalUrl: "https://lorenzcleaners.com/",
  },
  sections: {
    header: {
      businessName: "Loren'z Cleaning LLC",
    },
    sectionB: {
      heroTitle: "Revitalize Your Space with Loren'z Cleaning",
      heroSubtitle: "Exceptional and Thorough Cleaning Services in Queens, NY",
      learnAboutText: "Get Your Free Quote",
      phoneNumber: "3478709310",
      phoneLabel: "(347) 870-9310",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=",
      cardData: [
        {
          title: "Deep Cleaning",
          description:
            "Experience a pristine home with our expert deep cleaning service, thoroughly cleaning and disinfecting every surface for a spotless result.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Comprehensive commercial cleaning solutions from dusting and vacuuming to disinfecting, ensuring a sparkling clean and germ-free environment.",
        },
        {
          title: "Post-Construction Cleaning",
          description:
            "Ultimate satisfaction with our top-notch post-construction cleaning, removing debris and dust left behind from construction work.",
        },
      ],
      description:
        "Experience exceptional and thorough cleaning services for your home, office, or construction site with Loren'z Cleaning LLC in Queens, NY. Our trained professionals deliver pristine results.",
    },
    sectionC: {
      servicesTitle: "Our Professional Cleaning Services",
      servicesDescription:
        "Comprehensive cleaning solutions for residential and commercial spaces in Queens, NY. All cleaners are trained and insured for your peace of mind.",
      cards: [
        {
          title: "Residential & Deep Cleaning",
          description:
            "Professional residential cleaning and expert deep cleaning services using high-quality products with attention to every detail for a spotless, sanitized home.",
          imageSrc: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Residential Deep Cleaning Services",
        },
        {
          title: "Commercial & Office Cleaning",
          description:
            "Efficient and reliable commercial and office cleaning services maintaining a pristine work environment so you can focus on your business.",
          imageSrc: "https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Commercial Office Cleaning",
        },
        {
          title: "Standard & Construction Cleaning",
          description:
            "Standard cleaning services for regular maintenance and specialized post-construction cleaning to handle debris and dust removal.",
          imageSrc: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2076&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Standard and Construction Cleaning",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Standard Cleaning",
        "Weekly Cleaning Schedules",
        "Flexible Cancellation Policy",
        "All Cleaning Supplies Provided",
        "Customized Cleaning Plans",
      ],
    },
    sectionD: {
      aboutTitle: "About Loren'z Cleaning LLC",
      aboutImage: {
        src: "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/2367fa49-a75e-4d4a-8df7-3211f4d28aea471d.png?alt=media&token=d0194a46-8ed3-4428-b8d9-512fd97b2ee7",
        alt: "Loren'z Cleaning LLC Team",
      },
      aboutText: [
        "Loren'z Cleaning LLC is Queens' trusted cleaning service provider, delivering exceptional and thorough cleaning services for homes, offices, and construction sites. Our team of trained and insured professionals uses top-quality products to ensure every space is left spotless and sanitized.",
        "We provide all necessary cleaning supplies and offer flexible scheduling with at least weekly cleanings recommended for optimal results. Whether you need standard cleaning, deep cleaning, or specialized post-construction services, we handle the dirty work so you can enjoy a pristine living or working environment.",
      ],
    },
    sectionE: {
      profileImage: "https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/2367fa49-a75e-4d4a-8df7-3211f4d28aea471d.png?alt=media&token=d0194a46-8ed3-4428-b8d9-512fd97b2ee7",
      profileAlt: "Loren'z Cleaning LLC",
      businessName: "Loren'z Cleaning LLC",
      contact: {
        phone: "3478709310",
        phoneLabel: "(347) 870-9310",
        email: "info@lorenzcleaners.com",
        website: "https://lorenzcleaners.com/",
        address: "Queens, NY",
      },
      socialMedia: {
      },
    },
    sectionF: {
      address: "Queens, NY",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193914.123456789!2d-73.8370456!3d40.7282239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sQueens%2C%20NY!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;
